import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const English: IconDef = {
  svg: (
    <G>
      <Path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <Path
        d="M11.4779 12H23.9996C23.9996 10.9169 23.8553 9.86761 23.5863 8.86951H11.4779V12Z"
        fill="#D80027"
      />
      <Path
        d="M11.4779 5.73848H22.2384C21.5038 4.5398 20.5646 3.48028 19.4695 2.60803H11.4779V5.73848Z"
        fill="#D80027"
      />
      <Path
        d="M11.9997 23.9999C14.8239 23.9999 17.4197 23.0238 19.4695 21.3912H4.52991C6.57975 23.0238 9.17555 23.9999 11.9997 23.9999Z"
        fill="#D80027"
      />
      <Path
        d="M1.76105 18.2598H22.2385C22.8282 17.2975 23.2856 16.2457 23.5864 15.1294H0.413162C0.713959 16.2457 1.17132 17.2975 1.76105 18.2598Z"
        fill="#D80027"
      />
      <Path
        d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z"
        fill="#0052B4"
      />
    </G>
  ),
  svgStyles() {
    return {};
  },
};
